/**
 * Префиксы, начинающиеся на 8, которые нужно преобразовать в формат +7 (РК/РФ)
 */
export const REPLACEABLE_8_PREFIXES = ['89', '87'];
